module.exports = __webpack_public_path__ + "static/media/velvet.4c38fb44.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/velvet.jpeg
// module id = 301
// module chunks = 0